import React from "react";
import { useAuth } from "../../../utils/useAuth";
import Container from "../../../utils/Container";
import { Link, useNavigate } from "react-router";
import { useMemo } from "react";
import { secureStorage } from "../../../utils/secureStorage";
import { FaUmbrellaBeach, FaUsers } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { IoTime } from "react-icons/io5";
import { useState } from "react";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { Checkbox } from "@mui/joy";
import failedMas from "../../../assets/failed.png";
import PaymentMethod from "./section/PaymentMethod";

const TourBooking = () => {
  const navigate = useNavigate();
  const { isLoggedIn, user } = useAuth();
  const TourData = secureStorage.getItem("BookTour") || {};
  const [open, setOpen] = useState(false);

  const generateBookingId = () =>
    Math.random().toString(36).substring(2, 10).toUpperCase();
  const prefix = "DT-";
  const randomNumber = Math.floor(100000 + Math.random() * 900000); // 6-digit number
  const code = `${prefix}${randomNumber}`;
  const [FormData, setFormData] = useState({
    invoiceId: code,
    transactionId: generateBookingId(),
    invoiceFor: "Tour",
    type: "Tour",
    tourName: TourData?.data?.tourName || "",
    tourId: TourData?.data?.id || "",
    startDate: TourData?.data?.startDate || "",
    endDate: TourData?.data?.endDate || "",
    travellerName: user?.fullName || "",
    travellerPhone: user?.phoneNumber || "",
    actualPrice: TourData?.data?.price || 0,
    discount: TourData?.data?.discount || 0,
    totalAmount: 0,
    paymentNature: "Full",
    paymentStatus: "Unpaid",
    paymentMethod: 0,
    isAgreed: 0,
    bookedBy: user?.id || null,
    createdAt: new Date().toISOString(),
  });
  const [Error, setError] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  useEffect(() => {
    if (!TourData?.data) return;

    const totalAmount =
      TourData.data.price -
      (TourData.data.price * TourData.data.discount) / 100;

    setFormData((prev) => ({ ...prev, totalAmount }));
  }, [TourData?.data?.price, TourData?.data?.discount]);
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };
  const handlePayNow = async () => {
    if (!isLoggedIn) {
      navigate("/authentication/signin");
    } else if (!FormData.travellerName || !FormData.travellerPhone) {
      toast.error("Fill all the required fields");
    }
    if (FormData.isAgreed === 0) {
      setError(true);
    } else {
      setOpen(true);
    }
  };

  return (
    <>
      {open && FormData.isAgreed && (
        <PaymentMethod
          open={open}
          setOpen={setOpen}
          setFormData={setFormData}
          FormData={FormData}
          bookedBy={user}
          setError={setError}
          setIsProcessing={setIsProcessing}
        />
      )}
      {TourData?.data?.id ? (
        <div className="w-full h-full bg-[#f0f8fd] py-10 lg:py-5 mb-10 lg:mb-0 ">
          <Container>
            <div className="p-0 lg:p-8">
              <div className="block lg:flex gap-3">
                <div className="flex-1 p-0 lg:p-4 rounded-lg space-y-5">
                  {isLoggedIn === false && (
                    <div className="p-4 bg-white border rounded-lg">
                      <p className="text-black/70 text-sm">
                        <Link to={"/authentication/signin"}>
                          <span className="text-blue-500 font-bold">
                            Please Login First
                          </span>{" "}
                        </Link>
                        to have booking confirmation and hotel contact
                        information in your email and SMS.
                      </p>
                    </div>
                  )}
                  <div className="border p-3 rounded-lg  bg-white">
                    <p className="text-xl font-bold">
                      {TourData?.data?.tourName}
                    </p>
                  </div>
                  <div className="border p-3 rounded-lg grid grid-cols-2 lg:grid-cols-4 gap-3 bg-white">
                    <div className="flex justify-start items-center gap-2 p-4">
                      <div>
                        <FaUmbrellaBeach className="text-2xl" />
                      </div>
                      <div>
                        <p className="text-xs text-black/70">Tour Start:</p>
                        <p className="text-md font-bold">
                          {new Date(TourData.data.startDate).toLocaleString(
                            "en-US",
                            {
                              month: "short",
                            },
                          )}{" "}
                          {new Date(TourData.data.startDate).getDate()} to{" "}
                          {new Date(TourData.data.endDate).toLocaleString(
                            "en-US",
                            {
                              month: "short",
                            },
                          )}{" "}
                          {new Date(TourData.data.endDate).getDate()}
                        </p>
                      </div>
                    </div>
                    <div className="flex justify-start items-center gap-2">
                      <div>
                        <FaLocationDot className="text-2xl" />
                      </div>
                      <div>
                        <p className="text-xs text-black/70">Location:</p>
                        <p className="text-md font-bold">
                          {TourData.data.city}, {TourData.data.country}
                        </p>
                      </div>
                    </div>
                    <div className="flex justify-start items-center gap-2 p-4">
                      <div>
                        <FaUsers className="text-2xl" />
                      </div>
                      <div>
                        <p className="text-xs text-black/70">Tour Size:</p>
                        <p className="text-md font-bold">
                          {TourData.data.minPeople} to{" "}
                          {TourData.data.maxiPeople} People
                        </p>
                      </div>
                    </div>
                    <div className="flex justify-start items-center gap-2 p-4">
                      <div>
                        <IoTime className="text-2xl" />
                      </div>
                      <div>
                        <p className="text-xs text-black/70">Tour Duration:</p>
                        <p className="text-md font-bold">
                          {(new Date(TourData.data.endDate) -
                            new Date(TourData.data.startDate)) /
                            (1000 * 60 * 60 * 24)}{" "}
                          Days
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="border p-3 rounded-lg  bg-white space-y-3">
                    <div>
                      <label htmlFor="" className="text-xs">
                        Traveller Name
                      </label>
                      <input
                        type="text"
                        className="px-3 py-2 border rounded-lg text-sm w-full focus:outline-none"
                        placeholder="Enter your full name"
                        id="travellerName"
                        value={FormData.travellerName}
                        onChange={handleChange}
                      />
                    </div>
                    <div>
                      <label htmlFor="" className="text-xs">
                        Traveller Phone Number
                      </label>
                      <input
                        type="number"
                        className="px-3 py-2 border rounded-lg text-sm w-full focus:outline-none"
                        placeholder="Enter your phone number"
                        id="travellerPhone"
                        value={FormData.travellerPhone}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="w-full lg:w-[300px] pt-4 ">
                  <div className="w-full bg-white rounded-lg overflow-hidden">
                    <div className="p-3 bg-[#d8ecff]">
                      <p className="font-bold"> Tour Booking Breakdown</p>
                    </div>
                    {TourData?.data ? (
                      <div className="space-y-3 p-4">
                        <div className="flex justify-between items-center">
                          <p className="text-sm font-bold text-black/80">
                            Regular Price:
                          </p>
                          <p className="text-md font-bold text-black/80">
                            {TourData.data.price.toFixed(0)} BDT
                          </p>
                        </div>
                        <div className="flex justify-between items-center">
                          <p className="text-sm font-bold text-black/80">
                            Discount:
                          </p>
                          <p className="text-md font-bold text-black/80">
                            {TourData.data.discount}%
                          </p>
                        </div>
                        <div className="flex justify-between items-center">
                          <p className="text-sm font-bold text-black/80">
                            Total Price:
                          </p>
                          <p className="text-md font-bold text-black/80">
                            {TourData.data.price -
                              (TourData.data.price * TourData.data.discount) /
                                100}{" "}
                            BDT
                          </p>
                        </div>
                        <div>
                          <p className="text-xs text-black text-center">
                            * This price is for per person.
                          </p>
                        </div>
                      </div>
                    ) : (
                      <div className="flex justify-center bg-[#d8ecff3f] items-center py-28">
                        <p className="text-center text-sm text-black/50">
                          Data is not available!
                        </p>
                      </div>
                    )}

                    <div className="px-2">
                      <button
                        onClick={handlePayNow}
                        className={`px-4 py-3  text-nowrap bg-[#0e1435]  text-white w-full  cursor-pointer font-bold uppercase rounded-md`}
                      >
                        {isProcessing ? "Processing..." : "Pay Now"}
                      </button>
                      <div className="flex justify-start gap-1 items-start py-3 text-xs text-black/50 ">
                        <Checkbox
                          checked={FormData.isAgreed === 1}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              isAgreed: e.target.checked ? 1 : 0,
                            }))
                          }
                          style={
                            Error === true && FormData.isAgreed === 0
                              ? { border: "1px solid red", borderRadius: "4px" }
                              : {}
                          }
                        />

                        <div>
                          <p className="text-xs">
                            Agreed to the{" "}
                            <Link
                              to="/terms-and-conditions"
                              className="text-blue-500 "
                            >
                              Terms and conditions
                            </Link>
                            ,{" "}
                            <Link
                              to="/privacy-policy"
                              className="text-blue-500 "
                            >
                              Privacy Policy
                            </Link>
                            ,{" "}
                            <Link
                              to="/refund-policy"
                              className="text-blue-500 "
                            >
                              Refund Policy
                            </Link>
                            ,{" "}
                            <Link
                              to="/delivery-policy"
                              className="text-blue-500 "
                            >
                              Deliver Policy
                            </Link>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
      ) : (
        <div>
          <Container>
            <div className="flex flex-col items-center justify-center h-full py-32">
              <div className="w-32 lg:w-48 h-full">
                <img
                  src={failedMas}
                  className="w-full h-full object-contain"
                  alt=""
                />
              </div>
              <p className="text-md lg:text-lg font-semibold text-center">
                Sorry😔! You've not booked any tour, please do!
              </p>
              <div className="mt-5">
                <button
                  className="bg-[#161f52] hover:bg-[#0a0e25] duration-300 text-white font-bold py-2 px-4 rounded"
                  onClick={() => navigate("/tours")}
                >
                  Check Your
                </button>
              </div>
            </div>
          </Container>
        </div>
      )}
    </>
  );
};

export default TourBooking;
